import { defineComponent, h, Transition } from "vue";
import { cssClass } from "@/utils/styled";

const slideClass = cssClass`
  &.slide-enter-from,
  &.slide-leave-to {
    transform: translateY(100%);
  }

  &.slide-enter-to,
  &.slide-leave-from {
    transform: translateY(0);
  }

  &.slide-enter-active,
  &.slide-leave-active {
    transition: transform 250ms ease-in-out;
  }
`;

export const SlideTransition = defineComponent({
  setup: (_, { slots }) => {
    return () =>
      h(
        Transition,
        {
          mode: "out-in",
          name: "slide",
          class: slideClass,
        },
        slots.default,
      );
  },
});
